var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIconAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 20.0833L26.75 25.25M2 12.3333C2 15.0739 3.15893 17.7022 5.22183 19.6401C7.28473 21.578 10.0826 22.6667 13 22.6667C15.9174 22.6667 18.7153 21.578 20.7782 19.6401C22.8411 17.7022 24 15.0739 24 12.3333C24 9.59276 22.8411 6.96444 20.7782 5.02656C18.7153 3.08869 15.9174 2 13 2C10.0826 2 7.28473 3.08869 5.22183 5.02656C3.15893 6.96444 2 9.59276 2 12.3333Z",
    stroke: "#458898",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconAzul);
export default __webpack_public_path__ + "static/media/searchIconAzul.e4810d2abceb71261ba8b02306894db8.svg";
export { ForwardRef as ReactComponent };